//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { AlertDTO, AlertDTO_EmptyObject } from 'src/app/core/models/system/riskline/riskline-alert.dto';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RisklineAlertsService } from 'src/app/core/services/riskline/riskline-alerts.service';
import { RisklineSharedService } from 'src/app/core/services/riskline/riskline-shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector   : 'app-riskline-alert-modal-form',
  templateUrl: './riskline-alert-modal-form.component.html',
  styleUrls  : ['./riskline-alert-modal-form.component.scss']
})
export class RisklineAlertModalFormComponent implements OnDestroy, OnInit {

  @Input() public alertId: string | undefined;

  @Output() public formCancelled: EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('risklineAlertModalForm', { static: false }) public risklineAlertModalForm!: TemplateRef<void>;

  private alertSub: Subscription | undefined;
  private modalRef: NgbModalRef | undefined;

  public alert    : AlertDTO=AlertDTO_EmptyObject();
  public isLoading: boolean=false;

  get modalBackGround() {
    let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
    return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false);
  }

  constructor(
    private configSystemService  : ConfigSystemService,
    private exceptionsService    : ExceptionsService,
    private modalService         : NgbModal,
    private risklineAlertsService: RisklineAlertsService,
    private risklineSharedService: RisklineSharedService
  ) { }

  public ngOnInit(): void {
    try { }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.alertSub?.unsubscribe();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cancelForm(): void {
    try {
      this.formCancelled.emit();
      this.modalRef?.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(alertId: string): void {
    try {
      if (!alertId)
        throw new Error('RisklineAlertModalFormComponent.openForm() - alertId is required');

      this.alertId  =alertId;
      this.alert    =AlertDTO_EmptyObject();
      this.isLoading=true;

      this.alertSub?.unsubscribe();
      this.alertSub=this.risklineAlertsService.getAlertById(alertId).subscribe({
        next : data => {
          if (data) this.alert=data;
          this.isLoading=false;
        },
        error: err => {
          this.isLoading=false;
          this.exceptionsService.handleException(new Error(err));
        }
      });

      this.openModal();
    }
    catch(e) {
      this.formCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getCategoryLabel(categoryId: number | null): string {
    try {
      return this.risklineSharedService.getCategoryLabel(categoryId ?? undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  public riskBadgeStyle(riskLevelId: number | null | undefined): { [key: string]: string; } {
    try {
      return this.risklineSharedService.getRiskLevelBadgeStyle(riskLevelId ?? undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return { 'background-color': '#878a9926', 'color': '#878a99' };
    }
  }

  public riskLabel(riskLevelId: number | null | undefined): string {
    try {
      return this.risklineSharedService.getRiskLevelLabelWithLevel(riskLevelId ?? undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  public trustHtml(value: string | undefined): any {
    try {
      return this.risklineSharedService.trustHtml(value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  private openModal(): void {
    try {
      this.modalRef=this.modalService.open(this.risklineAlertModalForm, {
        backdrop: this.modalBackGround,
        centered: true,
        keyboard: false,
        size    : msSize.Large
      });
    }
    catch(e) {
      this.formCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
